import styled from "styled-components";
import {IoIosArrowDown} from "react-icons/io";

const Head = styled.div`
  align-items: center;
  padding: 16px;
  background-color: #405dae;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export function ChatHeader({onClose}: {onClose: () => void}) {
  return (
    <>
      <Head className="flex justify-between items-center">
        <h3 className="font-bold text-lg">BugaBot</h3>
        <button
          onClick={onClose}
          className="text-white hover:text-gray-200 focus:outline-none">
          <IoIosArrowDown size={24} color="white" />
        </button>
      </Head>
    </>
  );
}
